export const CASE: string = "CasePromoCode";
export const BOSS_BATTLE_ATTACK_POINTS: string =
  "BossBattleAttackPointsPromoCode";
export const EXCHANGER: string = "ExchangerPromoCode";

const promoCodeEventTarget: EventTarget = new EventTarget();
export default promoCodeEventTarget;
